import * as React from 'react';

import type { SalesforceLead } from 'bundles/enterprise-admin-contracts/utils/SalesforceAPI';
import Table from 'bundles/internal-ui/components/table/Table';

type Props = {
  leads: SalesforceLead[];
  actions?: Array<{
    icon: string;
    tooltip: string;
    onClick: (lead: SalesforceLead) => void;
  }>;
};

const EnterpriseLeadTable: React.FC<Props> = ({ leads, actions }) => {
  const getColumns = () => {
    return [
      { key: 'firstName', name: 'First Name' },
      { key: 'lastName', name: 'Last Name' },
      { key: 'email', name: 'Email' },
      { key: 'id', name: 'Lead ID' },
      { key: 'company', name: 'Company' },
    ];
  };

  return (
    <div>
      <Table rows={leads} columns={getColumns()} rowId={(lead) => lead.id} actions={actions} />
    </div>
  );
};

export default EnterpriseLeadTable;
